export default [
  {
    path: '',
    component: () => import('@/views/search/SearchPage.vue'),
    meta: { 
      title:'Search', 
      requiresAuth: true,
      requiresAmazon: true
    },
  },
  {
    path: '/search',
    component: () => import('@/views/search/SearchResults.vue'),
    meta: { 
      title:'Search Results', 
      requiresAuth: true,
      requiresAmazon: true 
    }
  },
  {
    path: '/product/:asin',
    component: () => import('@/views/search/ProductDetails.vue'),
    meta: { 
      title:'Product Details', 
      requiresAuth: true,
      requiresAmazon: true 
    }
  },
  {
    path: '/search-bot',
    component: () => import('@/views/search-bot/ChatPage.vue'),
    meta: { 
      title:'Search Results', 
      requiresAuth: true,
      requiresAmazon: true 
    }
  }
]